// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zegx","buttons":"styles_buttons__PZo1X"};